import ace from 'ace-builds';
import { IAceEditor } from 'react-ace/lib/types';

export const createCustomCompleter = (autocompleteValuesRef: React.RefObject<string[]>) => {
  return {
    //Identifier for the completer
    identifierRegexps: [/[a-zA-Z_0-9$\u00A2-\uFFFF]/],

    //Main completion function
    getCompletions: (
      _editor: IAceEditor,
      _session: ace.Ace.EditSession,
      _pos: any,
      prefix: string,
      callback: (error: any, completions: ace.Ace.Completion[]) => void,
    ) => {
      // Filter words that start with the current prefix (case-insensitive)
      const currentValues = autocompleteValuesRef.current || [];
      const completions = currentValues
        .filter((word) => word.toLowerCase().includes(prefix.toLowerCase()))
        .map((word) => ({
          caption: word, // What appears in the dropdown
          value: `${word} `, // What gets inserted with a right white space
          score: 1000, // Priority (higher = appears first)
        }));

      // Call the callback with our completions
      callback(null, completions);
    },
  };
};

// Here we move the autocomplete popup into the forge dialog to avoid stacking context issues (popup rendering behind dialog)
// We move the popup container into the dialog element though not into the shadow dom of the forge dialog
export const setupAutocomplete = (editor: IAceEditor, customCompleter: ace.Ace.Completer) => {
  editor.completers = [customCompleter];

  if (!editor.completer) {
    const Autocomplete = ace.require('ace/autocomplete').Autocomplete;
    editor.completer = new Autocomplete();
  }
};

export const setupForgeDialogIntegration = (editor: IAceEditor) => {
  // Bind the editor reference to avoid the focus error
  editor.completer.editor = editor;
  // initialize the popup
  const popup = editor.completer.getPopup();
  // get forge dialog element
  const targetElement = document.getElementById('advanced-totaling-dialog');
  // Move the popup to be a child of the target element
  if (targetElement && popup.container) {
    targetElement.appendChild(popup.container);
  }
};
